import { render } from "./CategoryUpsert.vue?vue&type=template&id=0b3810ec"
import script from "./CategoryUpsert.vue?vue&type=script&lang=js"
export * from "./CategoryUpsert.vue?vue&type=script&lang=js"

import exportComponent from "/home/jhg/tagforest/tagforest-frontend-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__